module.exports = __webpack_public_path__ + "img/1372389810.fd6d18bd.jpg";